const axios = require('axios')
const $cookies = require('vue-cookies')
const ga = require('./ga')
const storage = require('./storage')
const configs = require('../config/configs')

const setGaECTracking = (items) => {
  let products = items.map((v) => {
    if (v.ptype === 0) {
      return {
        id: v.pid,
        item_price: v.price,
        name: v.name,
        price: v.price,
        quantity: v.qty,
        sku: v.pid,
      }
    } else {
      return null
    }
  })
  products = products.filter((v) => !!v)
  ga.ec.addtocart(products)
}

const moduleFunc = {
  getTicket: () => {
    return $cookies.get('FEEC-B2C-TICKET')
  },
  getMemberId: () => {
    return $cookies.get('FEEC-B2C-UID')
  },
  addToCartBeforeCheck: (cartType, cartItem) => {
    const ticket = moduleFunc.getTicket()
    const memberID = moduleFunc.getMemberId()
    if (!ticket || !memberID) {
      storage.set('tempCartType', cartType, configs.webCacheExpireTime, true)
      storage.set(
        'tempCart',
        cartItem,
        configs.webCacheExpireTime,
        true
      )
      window.location.href =
        configs.loginDomain() +
        '/mobileweb/login?requestURL=' +
        encodeURIComponent(location.href)
      return false
    } else {
      return true
    }
  },
  addToCart: (payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post('shoppingcart', payload, {
          withCredentials: true,
        })
        .then((res) => {
          const data = res.data
          if (data.response.status === 'OK') {
            storage.set(
              'transactionCartType',
              this.cartType,
              configs.webCacheExpireTime
            )
            setGaECTracking(payload)
            resolve(data)
          } else {
            reject(data)
          }
        })
    })
  },
}
module.exports = moduleFunc
